import React, { useEffect } from "react";
import "./Forgetpassword.css";
import { Form, Input, Button, notification } from "antd";
import { ForgetPasswordActionHandler } from "../../Redux/Actions/common/ForgetPassword";
import { useDispatch, useSelector } from "react-redux";
import Index from "../Index";
import { Link, useNavigate } from "react-router-dom";

const Forgetpassword = () => {
  const mainLogo = "/assets/QA_Logo.svg";
  let dispatch = useDispatch();
  let Navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const forgetdata = useSelector((state) => state?.ForgetPasswordData);
  const onFinish = (values) => {
    dispatch(ForgetPasswordActionHandler(values));
  };
  const openNotificationWithIcon = (type) => {
    api[type]({
      message: forgetdata?.forget_data?.message,
    });
  };
  useEffect(() => {
    if (forgetdata?.forget_data) {
      openNotificationWithIcon("success");
      setTimeout(() => {
        Navigate("/forgetVerifiction");
      }, 2000);
    }
  }, [forgetdata]);
  return (
    <>
      <div className="forgetpass-container">
        <Index />
        {contextHolder}
        <div className="forgetpassword-main">
          <div className="forgetpassword-div">
            <div className="center-img">
              <img src={mainLogo} alt="" className="centered-image" />
            </div>

            <p className="forgetpassword_text">Forgot Password</p>
            <p className="forgetpassword_midtext">
              {" "}
              Enter your registered email address to reset the password
            </p>

            <Form
              name="forgetpassword"
              initialValues={{ remember: true }}
              onFinish={onFinish}
              style={{
                maxWidth: "400px",
                margin: "auto",
                marginTop: "55px",
              }}
            >
              <label>Your email</label>
              <Form.Item
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please input your email!",
                  },
                  {
                    type: "email",
                    message: "Please enter a valid email address",
                  },
                ]}
              >
                <Input placeholder="Enter your email" />
              </Form.Item>

              <Form.Item>
                <Button
                  style={{ marginTop: "20px" }}
                  type="primary"
                  htmlType="submit"
                  block
                  className="submit_login-btn"
                >
                  Send
                </Button>
                <div className="first-time_div  forget-to-login">
                  Already have an account ?
                  <Link to="/login">
                    <span> Sign in</span>
                  </Link>
                </div>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Forgetpassword;
